/* eslint-disable max-statements */
/* eslint-disable complexity */
import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { getAbExpirementVariant } from "../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";
import { FILTER_ENTITIES } from "../constants/app-constants";

const useModifiedFilters = (desktopCityNameFilterAllowed = false) => {
    const HIDDEN_FILTERS = useMemo(() => [FILTER_ENTITIES.MAKECITYNAME, FILTER_ENTITIES.MODELCITYNAME], []);
    const [validFilters, setValidFilters] = useState(HIDDEN_FILTERS);

    const selectAbExperiment = useMemo(() => (state) => (state || {}).abExperiment || {}, []);
    const abExperiment = useSelector(selectAbExperiment);

    const {
        webLocationHighlighting = {}
    } = abExperiment || {};

    const showWebLocationHighlightingVariantA = getAbExpirementVariant(webLocationHighlighting, EXPERIMENT_TYPE.VARIANT_A);

    useEffect(() => {
        if (showWebLocationHighlightingVariantA && !desktopCityNameFilterAllowed) {
            setValidFilters(prevFilters => {
                if (!prevFilters.includes(FILTER_ENTITIES.CITYNAME)) {
                    return [...prevFilters, FILTER_ENTITIES.CITYNAME];
                }
                return prevFilters;
            });
        }
    }, [showWebLocationHighlightingVariantA, desktopCityNameFilterAllowed]);

    const getModifiedFilters = useMemo(() => (selectedFilters) => {
        return selectedFilters.filter((item) => !validFilters.includes(item.filterKey));
    }, [validFilters]);

    const isSeoFilterPresent = useMemo(() => (selectedFilters) => {
        return selectedFilters.some(item => validFilters.includes(item.filterKey));
    }, [validFilters]);

    return {validFilters, getModifiedFilters, isSeoFilterPresent};
};

export default useModifiedFilters;